import { render, staticRenderFns } from "./PropertyTable.vue?vue&type=template&id=00f4bcab&scoped=true&"
import script from "./PropertyTable.vue?vue&type=script&lang=js&"
export * from "./PropertyTable.vue?vue&type=script&lang=js&"
import style0 from "./PropertyTable.vue?vue&type=style&index=0&id=00f4bcab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f4bcab",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VList } from 'vuetify/lib/components/VList';
import { VListTile } from 'vuetify/lib/components/VList';
import { VListTileAction } from 'vuetify/lib/components/VList';
import { VListTileActionText } from 'vuetify/lib/components/VList';
import { VListTileContent } from 'vuetify/lib/components/VList';
import { VListTileTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VDivider,VList,VListTile,VListTileAction,VListTileActionText,VListTileContent,VListTileTitle})
